export const dataAccountRegion = {
  type: 'string',
};

export const nullableDataAccountRegion = {
  type: [dataAccountRegion.type, 'null'],
};
